import React, { useEffect, useRef, useState } from 'react'
import { useStore } from '@/hooks/storeHooks'
import { useInViewport } from 'ahooks'
import cn from 'classnames'
import st from './index.scss'

/**
 *
 * 图片组件
 * 封装原生html标签，提供与原生相同的功能，使用方式不变，增加加载中图片
 *
 * @returns
 */
export default function Image({ src, className, ...props }) {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)
    const [viewport, setViewport] = useState(false)
    const imgageRef = useRef()
    const {
        tools: { loadImage },
        isZhumavip
    } = useStore()

    // inViewport: 是否可见	
    const [inViewport] = useInViewport(imgageRef.current);

    useEffect(() => {
        if (src) {
            setLoading(true)
            loadImage(src)
                .then(() => setLoading(false))
                .catch(() => setError(true))
        }
    }, [src])

    useEffect(() => {
        // 记录当前图片是否加载过
        inViewport && setViewport(inViewport)
    }, [inViewport])

    // 获取图片地址
    function getImgSrc() {
        let lodaingImg = isZhumavip() ? require('./images/zhumaLoading.png') : require('./images/zhongheLoading.png')

        if (error || loading || !viewport) {
            return lodaingImg
        } else {
            return src
        }
    }

    return <img className={cn({
        [st['img_common_style']]: true,
        [st['img_loading_style']]: error || loading || !viewport,
    }, className)} ref={imgageRef} {...props} src={getImgSrc()} />
}
